import { ReactNode } from 'react'
import styled from 'styled-components'

interface ComponentProps {
  mention: { icon?: ReactNode; name?: string }
  className?: string
  children?: ReactNode
}

const StyledRow = styled.span`
  && {
    display: inline-flex;
    justify-content: flex-start;
    margin-bottom: 3px;
    margin-top: 3px;
    margin-left: 5px;
    align-items: center;
    padding: 0 5px;
    color: #4a90e2;
    box-shadow: 0 0 2px 2px #7390d56e;
    border-radius: 4px;
    font-size: 12px;
    height: 22px;
  }
`

const StyledIcon = styled.div`
  svg {
    height: 20px;
    width: 20px;
    margin-right: 5px;
  }
`

const StyledImg = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 5px;
`

const MentionComponent = (props: ComponentProps) => {
  const { mention } = props
  return (
    <span>
      <StyledRow>
        {typeof mention.icon === 'string' ? (
          <StyledImg src={mention.icon} />
        ) : (
          <StyledIcon> {mention.icon} </StyledIcon>
        )}
        <span>{props.children}</span>
      </StyledRow>
    </span>
  )
}

export default MentionComponent
